import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type ListUnmatchedStatementItemsParams } from '@webapp/modules/accounts-payable/business-logic/interfaces/IStatementItemRepository'
import { statementItemRepository } from '../data-access/repositories/StatementItemRepository'

const base = ['statement-items']

// Partial key for command invalidation (statement-item CRUD, match commands,
// statement import).
export const STATEMENT_ITEM_UNMATCHED_BASE_KEY = [...base, 'unmatched']

export const statementItemQueries = {
  unmatched: (params: ListUnmatchedStatementItemsParams) => ({
    queryKey: buildQueryKey([...STATEMENT_ITEM_UNMATCHED_BASE_KEY, params]),
    queryFn: () => statementItemRepository.listUnmatched(params),
  }),
}
